import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { BASE_URL } from "../services/api";

export default function Login() {

    const navigate = useNavigate();
    const { login } = useAuth();

    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });

    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {

        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        // Prevent multiple clicks
        if (loading) return;

        setLoading(true);
        setError("");

        try {

            const response = await axios.post(
                `${BASE_URL}/auth/login`,
                formData
            );

            login(response.data.access_token);

            navigate("/dashboard");

        } catch (err) {

            if (err.response) {

                // Server responded with status code

                if (err.response.status === 401) {
                    setError("Invalid email or password");
                } else if (err.response.status === 500) {
                    setError("Server error. Please try again later.");
                } else {
                    setError("Login failed");
                }

            } else if (err.request) {

                // Request made but no response received
                setError("Network error. Please check your internet.");

            } else {

                // Something else happened
                setError("Something went wrong");
            }
        } finally {

            setLoading(false);
        }
    };

    return (

        <div className="min-h-screen flex items-center justify-center bg-gray-100">

            <form
                onSubmit={handleSubmit}
                className="bg-white p-8 rounded shadow-md w-96"
            >

                <h2 className="text-2xl font-bold mb-6">
                    Partner Login
                </h2>

                {error && (
                    <p className="text-red-500 mb-4">
                        {error}
                    </p>
                )}

                <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    className="w-full border p-2 mb-4"
                    onChange={handleChange}
                    disabled={loading}
                />

                <input
                    type="password"
                    name="password"
                    placeholder="Password"
                    className="w-full border p-2 mb-4"
                    onChange={handleChange}
                    disabled={loading}
                />

                <button
                    type="submit"
                    disabled={loading}
                    className={`w-full py-2 rounded text-white ${loading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-blue-600 hover:bg-blue-700"
                        }`}
                >
                    {loading ? "Logging in..." : "Login"}
                </button>

            </form>

        </div>
    );
}